import React from "react"
import { withRouter, Switch } from "react-router-dom"
import LoadableComponent from "../utils/LoadableComponent"
import PrivateRoute from "../components/PrivateRoute/privateRoute"

const AdminHome = LoadableComponent(() => import("../pages/admin/home/index"));
const AdminAccounting = LoadableComponent(() => import("../pages/admin/accounting/index"));

const AdminAgency = LoadableComponent(() => import("../pages/admin/agency/index"));
const AdminBusiness = LoadableComponent(() => import("../pages/admin/business/index"));
const AdminCustomer = LoadableComponent(() => import("../pages/admin/customer/index"));
const AdminSetting = LoadableComponent(() => import("../pages/admin/setting/index"));

export default class Routes extends React.Component {
    render() {
        return (
            <Switch>
                <PrivateRoute exact path="/sys/home" component={AdminHome} />
                <PrivateRoute exact path="/sys/accounting" component={AdminAccounting} />
                <PrivateRoute exact path="/sys/agency" component={AdminAgency} />
                <PrivateRoute exact path="/sys/isp" component={AdminBusiness} />
                <PrivateRoute exact path="/sys/customer" component={AdminCustomer} />
                <PrivateRoute exact path="/sys/setting" component={AdminSetting} />
            </Switch>
        )
    }
}

